'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlickityDirective = FlickityDirective;

var _flickity = require('./flickity.controller');

function FlickityDirective($timeout, FlickityService) {
    'ngInject';

    var directive = {
        restrict: 'A',
        scope: {},
        bindToController: {
            bcFlickity: '@?',
            bcFlickityId: '@?'
        },
        compile: function compile() {
            return {
                pre: preLinkFunction,
                post: postLinkFunction
            };
        },
        controller: _flickity.FlickityController,
        controllerAs: 'vm'
    };

    return directive;

    function preLinkFunction($scope, $element, $attrs, $controller) {
        'ngInject';

        // If no ID was passed in

        if (!$controller.bcFlickityId) {
            // Use the element's ID if one exists
            if ($attrs.id) {
                $controller.bcFlickityId = $attrs.id;
            }
        }
    }

    /**
     * Post Link
     */
    function postLinkFunction($scope, $element, $attrs, $controller) {
        'ngInject';

        // Make sure this `create()` gets picked up in the next digest cycle

        $timeout(function () {

            // Initialize Flickity
            FlickityService.create($element[0], $controller.bcFlickityId, $controller.options).then(function (flickityInstance) {

                // Expose the Flickity instance and ID
                $controller.Flickity = flickityInstance.instance;
                $controller.bcFlickityId = flickityInstance.id;
            });
        });

        // When the directive is being destroyed
        var onDestroy = $scope.$on('$destroy', function (event) {
            // Make sure we destroy the Flickity instance
            FlickityService.destroy($controller.bcFlickityId);
        });
    }
} /* global Flickity */


/** WEBPACK FOOTER **
 ** ./src/flickity.directive.js
 **/